/* import __COLOCATED_TEMPLATE__ from './mastercard-logo-with-text-and-border-gradient.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();